import { useEffect, useReducer } from 'react';

function useExponentialBackoff(requestCount: number, initialInterval: number) {
  function requestIntervalReducer(_: any, requestCount: number) {
    const second = 1000;
    if (requestCount === 0) {
      return initialInterval;
    }
    if (requestCount <= 5) {
      return 2 * second;
    }
    if (requestCount <= 10) {
      return 4 * second;
    }
    if (requestCount <= 20) {
      return 8 * second;
    }
    if (requestCount <= 25) {
      return 10 * second;
    }
    throw new Error('System waited too long with no response');
  }

  const [requestInterval, setIntervalForRequestCount] = useReducer(
    requestIntervalReducer,
    initialInterval
  );

  useEffect(() => {
    setIntervalForRequestCount(requestCount);
  }, [requestCount]);

  return requestInterval;
}

export default useExponentialBackoff;
